module.exports = __webpack_public_path__ + "static/media/2FA.9ab44356.png";